import { Client } from '@/../client-generator/generated-clients/welcome';
import axiosInstance from '../utils/axios-instance';

const welcomeClient = new Client('', axiosInstance);

export default welcomeClient;
